import React, { useEffect, useState } from "react";
import { ROUTES } from "../../constants/routes";
import { useNavigate, useParams } from "react-router-dom";
import LoadingSpinner from "../../components/UI/loadingSpinner/LoadingSpinner";
import { Link } from "react-router-dom";
import { IEmployee } from "../../interfaces/employee.interface";
import { getApi } from "../../services/http.service";
import moment from "moment";
import { Icon } from "@iconify/react";

const ReporterDetail = () => {
  const params = useParams();
  const navigate = useNavigate();
  const [employee, setEmployee] = useState<IEmployee>();
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    fetchDistributor();
  }, []);

  const fetchDistributor = async () => {
    try {
      const result = await getApi(ROUTES.EMPLOYEE_BY_ID + params?.reporterId);
      setEmployee(result?.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  let template;

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <>
      <div>
        <div className="d-flex">
          <button className="nav-link" onClick={() => navigate(-1)}>
            <Icon icon="material-symbols:arrow-back-rounded" fontSize={25} />
          </button>
          <h4>Reporter</h4>
        </div>
        <section>
          <h3>{employee?.fullName}</h3>
          <div className="my-3">
            <h6>Email: {employee?.email}</h6>
            <h6>Phone: {employee?.phone}</h6>
            <h6>
              Added On: {moment(employee?.createdAt).format("DD MMMM YYYY")}
            </h6>
            <h5>Address</h5>
            <div>
              <p>{employee?.address?.street}</p>
              <p>
                {employee?.address?.city}, {employee?.address?.state},{" "}
                {employee?.address?.pincode}
              </p>
            </div>
            <div></div>
          </div>
        </section>
      </div>
    </>
  );
};

export default ReporterDetail;
